import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/1994-Fundraising.jpg');

const BciaContent = () => {
    return (
        <>
            <TimelineVideo videoId="JOMXxuxHJRo" imagePreview={VideoPreview} />
            <h4>
                Breast Cancer Institute of Australia
            </h4>
            <p>
                    We begin building a community of supporters by establishing our fundraising department, Breast Cancer Institute of Australia in 1994. Since that time our fundraising department has raised more than $100 million for our breast cancer research program.
            </p>
        </>
    );
}

export default BciaContent;